module.exports = __webpack_public_path__ + "img/1030.67db143d.svg";